import React, { useEffect, useState, useContext } from "react";
import { Link, NavLink } from "react-router-dom";
import { AuthContext } from "../../auth/authContext";
import M from "materialize-css";
import Swal from "sweetalert2";
import { DialogValidation } from "../DialogValidation";
import { saveRegisterStatusByCompany } from "../../helpers/statusFunc";
import { createNewCompany } from "../../helpers/companiesFunc";

export const FormCompanies = () => {
  const { currentUser } = useContext(AuthContext);
  const initialValues = {
    accesDoc: 1,
    idCompany: "",
    keyAccess: "",
    name: "",
    routing: "",
    shortName: "",
    storageUrl: "",
    tokenAccess: "",
    tokenAccessERP: "",
    phone: "",
    address: "",
    status: 1,
    userApp: 0,
    userWeb: 0,
    locationRadius: 0.0,
    validateArrival: 2,
    application: "D",
    url_mserp: ""
  };
  const [formValues, setFormValues] = useState(initialValues);

  const [formErrors, setFormErrors] = useState({
    idCompany: false,
    accesDoc: false,
    keyAccess: false,
    name: false,
    routing: false,
    shortName: false,
    status: false,
    userApp: false,
    userWeb: false,
    storageUrl: false,
    tokenAccess: false,
    tokenAccessERP: false,
    phone: false,
    address: false,
    validateArrival: false,
    locationRadius: false,
    application: false
  });

  useEffect(() => {
    let isMounted = true;
    const select = document.querySelectorAll("select");
    M.FormSelect.init(select);

    return () => {
      isMounted = false;
    };
  }, []);

  // const handleChange = (e) => {
  //   const { name, value } = e.target;

  //   setFormValues({ ...formValues, [name]: value });

  //   setFormErrors((prev) => ({
  //     ...prev,
  //     [name]: value.trim() === "",
  //   }));


  // };

  // const handleBlur = (e) => {
  //   const { name, value } = e.target;
  //   setFormErrors((prev) => ({
  //     ...prev,
  //     [name]: value.trim() === "",
  //   }));
  // }

  const handleChange = (e) => {
    const { name, value } = e.target;
  
    // Actualiza el valor
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  
    // Validación condicional por tipo de campo
    if (name === "validateArrival") {
      // No marcar error, se valida por useEffect o en validate()
      return;
    }
  
    if (name === "locationRadius") {
      const radiusValid = parseFloat(value) > 0;
      setFormErrors((prev) => ({
        ...prev,
        locationRadius: parseInt(formValues.validateArrival) === 1 && !radiusValid,
      }));
      return;
    }
  
    // Para el resto de campos
    setFormErrors((prev) => ({
      ...prev,
      [name]: value.trim() === "",
    }));
  };


  const handleBlur = (e) => {
    const { name, value } = e.target;
  
    if (name === "locationRadius") {
      const radiusValid = parseFloat(value) > 0;
      setFormErrors((prev) => ({
        ...prev,
        locationRadius: parseInt(formValues.validateArrival) === 1 && !radiusValid,
      }));
      return;
    }
  
    setFormErrors((prev) => ({
      ...prev,
      [name]: value.trim() === "",
    }));
  };



  const handleSelectTypeStatus = (e) => {
    console.log(e.target.value);
    // selectTypeStatusState(parseInt( e.target.value));
  };

  useEffect(() => {
    if (parseInt(formValues.validateArrival) === 1) {
      const isValid = formValues.locationRadius && parseFloat(formValues.locationRadius) > 0;
      setFormErrors((prev) => ({ ...prev, locationRadius: !isValid }));
    } else {
      // Si no se requiere validación, limpiar errores
      setFormErrors((prev) => ({ ...prev, locationRadius: false }));
    }
  }, [formValues.validateArrival, formValues.locationRadius]);

  const validate = (values) => {
    let msgError = "";
    let newErrr = "";
    let flag;
    console.log(formValues);
    const regExpUrlIps =
      /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?|^((http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/;
    const regEXpPhone = /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/;
    if (values.idCompany === "") {
      msgError += "El id de la compañía es requerido.\n";
      flag = false;
      setFormErrors((prev) => ({ ...prev, ["idCompany"]: true, }));
    }
    if (values.keyAccess === "") {
      msgError += "La llave de acceso es requerida.\n";
      flag = false;
      setFormErrors((prev) => ({ ...prev, ["keyAccess"]: true, }));
    }
    if (values.name === "") {
      msgError += "El nombre de la compañía es requerida.\n";
      flag = false;
      setFormErrors((prev) => ({ ...prev, ["name"]: true, }));
    }
    if (values.routing === "") {
      msgError += "La URL del MSERP es requerida.\n";
      flag = false;
      setFormErrors((prev) => ({ ...prev, ["routing"]: true, }));
    }
    if (values.shortName === "") {
      msgError += "El nombre corto de la compañía es requerida.\n";
      flag = false;
      setFormErrors((prev) => ({ ...prev, ["shortName"]: true, }));
    }
    if (values.phone === "") {
      msgError += "El teléfono de la compañía es requerida.\n";
      flag = false;
      setFormErrors((prev) => ({ ...prev, ["phone"]: true, }));
    }
    if (values.address === "") {
      msgError += "La dirección de la compañía es requerida.\n";
      flag = false;
      setFormErrors((prev) => ({ ...prev, ["address"]: true, }));
    }

    if (values.userApp === 0) {
      msgError += "El número de licencias de la app son requeridas.";
      flag = false;
      setFormErrors((prev) => ({ ...prev, ["userApp"]: true, }));
    }
    if (values.userWeb === 0) {
      msgError += "El número de licencias de la web son requeridas.";
      flag = false;
      setFormErrors((prev) => ({ ...prev, ["userWeb"]: true, }));
    }
    if (values.storageUrl === "") {
      msgError += "La URL de firebase es requerida.";
      flag = false;
      setFormErrors((prev) => ({ ...prev, ["storageUrl"]: true, }));
    }

    // if (values.validateArrival === 1) {
    //   if (values.locationRadius === 0 || values.locationRadius === '') {
    //     flag = false;
    //     setFormErrors((prev) => ({ ...prev, ["locationRadius"]: true, }));
    //   }
    // }

    if (parseInt(values.validateArrival) === 1) {
      if (!values.locationRadius || parseFloat(values.locationRadius) <= 0) {
        msgError += "El radio de ubicación es requerido si se valida arribo.\n";
        flag = false;
        setFormErrors((prev) => ({ ...prev, locationRadius: true }));
      }
    }

    if (values.tokenAccess === "") {
      msgError += "La llave de acceso es requerida.";
      flag = false;
      setFormErrors((prev) => ({ ...prev, ["tokenAccess"]: true, }));
    }
    if (values.tokenAccessERP === "") {
      msgError += "El token de acceso del ERP es requerido.";
      flag = false;
      setFormErrors((prev) => ({ ...prev, ["tokenAccessERP"]: true, }));
    }

    

    if (msgError !== "" || newErrr !== "") {
      msgError = "Falta proporcionar los datos obligatorios que se especifican.";
      Swal.fire({
        title: "Aviso",
        text: newErrr !== "" ? newErrr : msgError,
        icon: "warning",
      });

      flag = false;

    } else {
      flag = true;
    }

    return flag;
  };

  const handlerSaveRegister = async (e) => {
    e.preventDefault();

    const flag = validate(formValues);

    if (flag === true) {
      if (parseInt(formValues.validateArrival) === 2) {
        formValues.locationRadius = 0.0;
      }
      const data = {
        accesDoc: parseInt(formValues.accesDoc),
        idCompany: formValues.idCompany.toUpperCase().trim(),
        keyAccess: formValues.keyAccess.trim(),
        name: formValues.name.trim(),
        routing: formValues.routing.trim(),
        shortname: formValues.shortName.trim(),
        status: parseInt(formValues.status),
        userApp: parseInt(formValues.userApp),
        userWeb: parseInt(formValues.userWeb),
        storageUrl: formValues.storageUrl,
        tokenAccess: formValues.tokenAccess,
        tokenAccessERP: formValues.tokenAccessERP,
        phone: formValues.phone,
        address: formValues.address,
        validateArrival: parseInt(formValues.validateArrival),
        // locationRadius: parseFloat(formValues.locationRadius).toFixed(2),
        locationRadius: formValues.locationRadius, 
        application: formValues.application, 
        url_mserp: formValues.url_mserp.trim()
      };

      const result = await createNewCompany(data);

      if (result === 1) {
        Swal.fire({
          title: "Exitoso",
          text: "Empresa registrada.",
          confirmButtonText: "Ok",
          icon: "success",
        }).then(function () {
          setFormValues(initialValues);
          window.location.reload();
        });
      } else {
        //
        Swal.fire({
          title: "Aviso",
          text: "No se pudo registrar la empresa.",
          confirmButtonText: "Ok",
          icon: "warning",
        }).then(function () {
          setFormValues(initialValues);
          window.location.reload();
        });

      }

    }
  };

  return (
    <>
      {currentUser.typeUser === 1 ? (
        <>
          {" "}
          <div className="containerUser" style={{ position: "absolute" }}>
            <div
              className="contentFormCompany"
              style={
                {
                  /*paddingTop:'300px'*/
                }
              }
            >
              <div className="col s12 m12 l12 center">
                <h4>Registro de compañías</h4>
                <br></br>
                <form className="col s12 m12 l12 ">
                  <div className="row" style={{ marginTop: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 5 }}>

                    <div className={`col s12 m3 l3}`} >
                      <div className={`input-field  lighten-5`} style={{ marginTop: 2, marginBottom: 2, paddingTop: 2, paddingBottom: 2, height: "1px" }}>
                        <label htmlFor="idCompany" className="active">
                          <b>Id de la compañía</b>
                          {formErrors.idCompany && (
                            <span style={{ color: 'red', fontSize: '18px', marginLeft: '5px' }}>●</span>
                          )}
                        </label>
                      </div>
                      <div className={`input-field  white lighten-5 inputRegisterUser  col s12 m12 l12}`}  >
                        <input
                          name="idCompany"
                          type="text"
                          required
                          id="statusCaption"
                          value={formValues.idCompany}
                          maxLength={15}
                          onChange={handleChange} 
                          onBlur={handleBlur}
                          style={formErrors.idCompany ? { borderColor: 'red' } : { }}
                        />
                      </div>
                    </div>

                    <div className="col s12 m1 l1"></div>

                    <div className={`col s12 m4 l4}`} >
                      <div className={`input-field  lighten-5`} style={{ marginTop: 2, marginBottom: 2, paddingTop: 2, paddingBottom: 2, height: "1px" }}>
                        <label htmlFor="name" className="active">
                          <b>Nombre de la compañía</b>
                          {formErrors.name && (
                            <span style={{ color: 'red', fontSize: '18px', marginLeft: '5px' }}>●</span>
                          )}
                        </label>
                      </div>
                      <div className="input-field  white lighten-5 inputRegisterUser  col s12 m12 l12">
                        <input
                          name="name"
                          type="text"
                          required
                          id="statusCaption"
                          value={formValues.name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          maxLength={500}
                        />
                      </div>
                    </div>

                    <div className="col s12 m1 l1"></div>

                    <div className={`col s12 m4 l4}`} >
                      <div className={`input-field  lighten-5`} style={{ marginTop: 2, marginBottom: 2, paddingTop: 2, paddingBottom: 2, height: "1px" }}>
                        <label htmlFor="shortName" className="active">
                          <b>Nombre corto compañía</b>
                          {formErrors.shortName && (
                            <span style={{ color: 'red', fontSize: '18px', marginLeft: '5px' }}>●</span>
                          )}
                        </label>
                      </div>
                      <div className="input-field  white lighten-5 inputRegisterUser  col s12 m12 l12">
                        <input
                          name="shortName"
                          type="text"
                          required
                          id="statusCaption"
                          value={formValues.shortName}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          maxLength={10}
                        />
                      </div>
                    </div>

                    
                  </div>

                  <div className="row" style={{ marginTop: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 5 }}>
                    <div className={`col s12 m12 l12}`} >
                      <div className={`input-field  lighten-5`} style={{ marginTop: 2, marginBottom: 2, paddingTop: 2, paddingBottom: 2, height: "1px" }}>
                        <label htmlFor="address" className="active">
                          <b>Dirección de la compañía</b>
                          {formErrors.address && (
                            <span style={{ color: 'red', fontSize: '18px', marginLeft: '5px' }}>●</span>
                          )}
                        </label>
                      </div>
                      <div className="input-field  white lighten-5 inputRegisterUser  col s12 m12 l12">
                        <input
                          name="address"
                          type="text"
                          required
                          id="statusCaption"
                          value={formValues.address}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          maxLength={150}
                        />
                      </div>
                    </div>

                  </div>

                  <div className="row" style={{ marginTop: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 5 }}>

                    <div className={`col s5 m5 l5}`} >
                      <div className={`input-field  lighten-5`} style={{ marginTop: 2, marginBottom: 2, paddingTop: 2, paddingBottom: 2, height: "1px" }}>
                        <label htmlFor="phone" className="active">
                          <b>Teléfono</b>
                          {formErrors.phone && (
                            <span style={{ color: 'red', fontSize: '18px', marginLeft: '5px' }}>●</span>
                          )}
                        </label>
                      </div>
                      <div className="input-field  white lighten-5 inputRegisterUser  col s12 m12 l12">
                        <input
                          name="phone"
                          type="tel"
                          required
                          id="statusCaption"
                          value={formValues.phone}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          maxLength={25}
                        />
                      </div>
                    </div>

                    <div className="col s12 m1 l1"></div>

                    <div className={`col s2 m2 l2}`} >
                      <div className={`input-field  lighten-5`} style={{ marginTop: 2, marginBottom: 2, paddingTop: 2, paddingBottom: 2, height: "1px" }}>
                        <label className="active">
                          <b>Estatus</b>
                        </label>
                      </div>
                      <div className="input-field  white lighten-5 inputRegisterUser col s12 m12 l12">
                        <select
                          name="status" 
                          defaultValue="1" 
                          onChange={handleChange}
                          required
                          id="mySelectStatus"
                          value={formValues.status} >
                          <option key="1" value="1">
                            Activo
                          </option>
                          <option key="2" value="2">
                            Inactivo
                          </option>
                        </select>
                      </div>
                    </div>

                  </div>

                  <div className="row" style={{ marginTop: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 5 }}>

                    <div className={`col s5 m5 l5}`} >
                      <div className={`input-field  lighten-5`} style={{ marginTop: 2, marginBottom: 2, paddingTop: 2, paddingBottom: 2, height: "1px" }}>
                        <label htmlFor="keyAccess" className="active">
                          <b>Llave de acceso</b>
                          {formErrors.keyAccess && (
                            <span style={{ color: 'red', fontSize: '18px', marginLeft: '5px' }}>●</span>
                          )}
                        </label>
                      </div>
                      <div className="input-field  white lighten-5 inputRegisterUser  col s12 m12 l12">
                        <input
                          name="keyAccess"
                          // placeholder="Llave de acceso"
                          type="text"
                          required
                          id="statusCaption"
                          value={formValues.keyAccess}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          maxLength={10}
                        />
                      </div>
                    </div>

                    <div className="col s12 m1 l1"></div>

                    <div className={`col s5 m5 l5}`} >
                      <div className={`input-field  lighten-5`} style={{ marginTop: 2, marginBottom: 2, paddingTop: 2, paddingBottom: 2, height: "1px" }}>
                        <label className="active">
                          <b>Solicitar acceso a la documentación</b>
                        </label>
                      </div>
                      <div className="input-field white lighten-5 inputRegisterUser  col s12 m12 l12">
                        {/* <label htmlFor="accesDoc" className="active">
                          Solicitar acceso a la documentación
                        </label>
                        <i className="tiny material-icons prefix iconPositionInput "></i> */}
                        <select
                          name="accesDoc"
                          onChange={handleChange}
                          required
                          id="mySelect"
                          //defaultValue={'DEFAULT'}
                          defaultValue="1" 
                          value={formValues.accesDoc}
                        >
                          <option key="1" value="1">
                            True
                          </option>
                          <option key="2" value="2">
                            False
                          </option>
                        </select>
                      </div>
                    </div>

                    
                  </div>

                  
                  <div className="row" style={{ marginTop: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 5 }}>

                    <div className={`col s5 m5 l5}`} >
                      <div className={`input-field  lighten-5`} style={{ marginTop: 2, marginBottom: 2, paddingTop: 2, paddingBottom: 2, height: "1px" }}>
                        <label htmlFor="routing" className="active">
                          <b>Url del MSERP</b>
                          {formErrors.routing && (
                            <span style={{ color: 'red', fontSize: '18px', marginLeft: '5px' }}>●</span>
                          )}
                        </label>
                      </div>
                      <div className="input-field  white lighten-5 inputRegisterUser  col s12 m12 l12">
                        <input
                          name="routing"
                          type="text"
                          required
                          id="statusCaption"
                          value={formValues.routing}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          maxLength={60}
                        />
                      </div>
                    </div>

                    <div className="col s12 m1 l1"></div>


                    <div className={`col s6 m6 l6}`} >
                      <div className={`input-field  lighten-5`} style={{ marginTop: 2, marginBottom: 2, paddingTop: 2, paddingBottom: 2, height: "1px" }}>
                        <label htmlFor="storageUrl" className="active">
                          <b>Url almacenaje de Firebase</b>
                          {formErrors.storageUrl && (
                            <span style={{ color: 'red', fontSize: '18px', marginLeft: '5px' }}>●</span>
                          )}
                        </label>
                      </div>
                      <div className="input-field  white lighten-5 inputRegisterUser  col s12 m12 l12">
                        <input
                          name="storageUrl"
                          type="text"
                          required
                          id="statusCaption"
                          value={formValues.storageUrl}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          maxLength={60}
                        />
                      </div>
                    </div>

                  </div>

                  <div className="row" style={{ marginTop: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 5 }}>

                    <div className={`col s5 m5 l5}`} >
                      <div className={`input-field  lighten-5`} style={{ marginTop: 2, marginBottom: 2, paddingTop: 2, paddingBottom: 2, height: "1px" }}>
                        <label htmlFor="tokenAccessERP" className="active">
                          <b>Token acceso al ERP</b>
                          {formErrors.tokenAccessERP && (
                            <span style={{ color: 'red', fontSize: '18px', marginLeft: '5px' }}>●</span>
                          )}
                        </label>
                      </div>
                      <div className="input-field  white lighten-5 inputRegisterUser  col s12 m12 l12">
                        <input
                          name="tokenAccessERP"
                          type="text"
                          required
                          id="statusCaption"
                          value={formValues.tokenAccessERP}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          maxLength={35}
                        />
                      </div>
                    </div>


                    <div className="col s12 m1 l1"></div>


                    <div className={`col s6 m6 l6}`} >
                      <div className={`input-field  lighten-5`} style={{ marginTop: 2, marginBottom: 2, paddingTop: 2, paddingBottom: 2, height: "1px" }}>
                        <label htmlFor="tokenAccess" className="active">
                          <b>Token acceso funciones Firebase</b>
                          {formErrors.tokenAccess && (
                            <span style={{ color: 'red', fontSize: '18px', marginLeft: '5px' }}>●</span>
                          )}
                        </label>
                      </div>
                      <div className="input-field  white lighten-5 inputRegisterUser  col s12 m12 l12">
                        <input
                          name="tokenAccess"
                          type="text"
                          required
                          id="statusCaption"
                          value={formValues.tokenAccess}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          maxLength={35}
                        />
                      </div>
                    </div>

                  </div>

                  <div className="row" style={{ marginTop: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 5 }}>

                    <div className={`col s5 m5 l5}`} >
                      <div className={`input-field  lighten-5`} style={{ marginTop: 2, marginBottom: 2, paddingTop: 2, paddingBottom: 2, height: "1px" }}>
                        <label className="active">
                          <b>¿Validar arribo de la unidad?</b>
                        </label>
                      </div>
                      <div className="input-field white lighten-5 inputRegisterUser  col s12 m12 l12">
                        <select
                          name="validateArrival"
                          onChange={handleChange}
                          required
                          id="mySelect"
                          defaultValue="1" 
                          value={formValues.validateArrival}
                        >
                          <option key="1" value="1">
                            True
                          </option>
                          <option key="2" value="2">
                            False
                          </option>
                        </select>
                      </div>
                    </div>

                    <div className="col s12 m1 l1"></div>

                    <div className={`col s3 m3 l3}`} >
                      <div className={`input-field  lighten-5`} style={{ marginTop: 2, marginBottom: 2, paddingTop: 2, paddingBottom: 2, height: "1px" }}>
                        <label htmlFor="locationRadius" className="active">
                          <b>Radio de ubicación</b>
                          {
                            formErrors.locationRadius && (
                            <span style={{ color: 'red', fontSize: '18px', marginLeft: '5px' }}>●</span>)
                          }
                        </label>
                      </div>
                      <div className="input-field  white lighten-5 inputRegisterUser col s12 m12 l12">
                        <input
                          name="locationRadius"
                          type="number"
                          className=""
                          required
                          id="type"
                          value={formValues.locationRadius}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          step=".01"
                          min={0}
                          max={10000000}
                        />
                      </div>
                    </div>

                  </div>

                  <div className="row" style={{ marginTop: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 0 }}>

                    <div className={`col s3 m3 l3}`} >
                      <div className={`input-field  lighten-5`} style={{ marginTop: 2, marginBottom: 2, paddingTop: 2, paddingBottom: 2, height: "1px" }}>
                        <label htmlFor="userApp" className="active">
                          <b>No licencias móvil</b>
                          {formErrors.userApp && (
                            <span style={{ color: 'red', fontSize: '18px', marginLeft: '5px' }}>●</span>
                          )}
                        </label>
                      </div>
                      <div className="input-field  white lighten-5 inputRegisterUser col s12 m12 l12">
                        <input
                          name="userApp"
                          type="number"
                          className=""
                          required
                          id="type"
                          value={formValues.userApp}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          min={0}
                        />
                      </div>
                    </div>

                    <div className="col s12 m1 l1"></div>

                    <div className={`col s3 m3 l3}`} >
                      <div className={`input-field  lighten-5`} style={{ marginTop: 2, marginBottom: 2, paddingTop: 2, paddingBottom: 2, height: "1px" }}>
                        <label htmlFor="userApp" className="active">
                          <b>No licencias web</b>
                          {formErrors.userWeb && (
                            <span style={{ color: 'red', fontSize: '18px', marginLeft: '5px' }}>●</span>
                          )}
                        </label>
                      </div>
                      <div className="input-field  white lighten-5 inputRegisterUser col s12 m12 l12">
                        <input
                          name="userWeb"
                          type="number"
                          className=""
                          required
                          id="type"
                          value={formValues.userWeb}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          min={0}
                        />
                      </div>
                    </div>

                    {/* AQUI AQUI AQUI */}

                    <div className="col s12 m1 l1"></div>

                    <div className={`col s3 m3 l3}`} >
                      <div className={`input-field  lighten-5`} style={{ marginTop: 2, marginBottom: 2, paddingTop: 2, paddingBottom: 2, height: "1px" }}>
                        <label className="active">
                          <b>Aplicación</b>
                        </label>
                      </div>
                      <div className="input-field white lighten-5 inputRegisterUser  col s12 m12 l12">
                        <select
                          name="application"
                          onChange={handleChange}
                          required
                          disabled 
                          id="application"
                          //defaultValue={'DEFAULT'}
                          defaultValue="D" 
                          value={formValues.accesDoc}
                        >
                          <option key="1" value="D">
                            Drivelog
                          </option>
                          <option key="2" value="M">
                            Madrinas
                          </option>
                        </select>
                      </div>
                    </div>



                  </div>


                  <div className="row" style={{ marginTop: 0, marginBottom: 0, paddingTop: 0, paddingBottom: 0 }}>
                    <div className={`col s5 m5 l5}`} >
                      <div className={`input-field  lighten-5`} style={{ marginTop: 2, marginBottom: 2, paddingTop: 2, paddingBottom: 2, height: "1px" }}>
                        <label htmlFor="url_mserp" className="active">
                          <b>Url del MSERP para Permisos</b>
                        </label>
                      </div>
                      <div className="input-field  white lighten-5 inputRegisterUser  col s12 m12 l12">
                        <input
                          name="url_mserp"
                          type="text"
                          id="url_mserp"
                          value={formValues.url_mserp}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          maxLength={60}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="registerDiv">
                    <button
                      className="btn waves-effect waves-light btnFromRegisterCreate"
                      onClick={handlerSaveRegister}
                      type="button"
                      name="Crear"
                    >
                      Crear
                    </button>
                    <Link
                      to="/"
                      className="btn btnFromLogin"
                      id="btnFromLoginRU"
                      style={{ background: "#5E5E68" }}
                    >
                      Salir
                    </Link>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div>
            <div className="containerUser">
              <h3 className="center">No tiene acceso a este apartado.</h3>
            </div>
          </div>
        </>
      )}
    </>
  );
};

